import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBContainer,
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
const LinkOpenModal = ({ url, label,toggleOpen,isOpen, setIsOpen }) => {

  return (
    <div className='align-items-center justify-content-center mb-0 text-start'>
    <MDBBtn color="link" rippleColor="dark" onClick={toggleOpen} className='text-start text-lowercase'>
    {label?.trim()}
  </MDBBtn>
      <MDBModal tabIndex="-1" open={isOpen} onClose={() => setIsOpen(false)}>
        <MDBModalDialog centered size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>{label}</MDBModalTitle>
              <MDBBtn
                type="button"
                className="btn-close"
                color="none"
                onClick={toggleOpen}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <iframe 
                src={url}
                title={label}
                style={{ width: '100%', height: '80vh', border: 'none' }}
              ></iframe>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn type="button" color="secondary" onClick={toggleOpen}>
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      </div>
  );
};
LinkOpenModal.propTypes = {
    url: PropTypes.func,
    label: PropTypes.func,
    toggleOpen: PropTypes.func,
    isOpen: PropTypes.bool,
    setIsOpen: PropTypes.func,
  };
  
export default LinkOpenModal;
